/* eslint-disable no-unsafe-optional-chaining */
import {
    Avatar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"

import { makeStyles } from "@mui/styles"

import api from "../../services/api"
import { i18n } from "../../translate/i18n"
import TableRowSkeleton from "../TableRowSkeleton"

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(1),
        maxHeight: "600px",
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
    repeatedContactsContainer: {
        display: "flex",
        justifyContent: "space-between",
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        ...theme.scrollbarStyles,
    },
    repeatedContactsMessage: {
        display: "flex",
        alignItems: "center",
        gap: 6,
    },
}))

function ContactSelectorModal({ isOpen, onClose, onImport }) {
    const classes = useStyles()

    const [contacts, setContacts] = useState([])
    const [hasMore, setHasMore] = useState(false)
    const [pageNumber, setPageNumber] = useState(1)
    const [searchParam] = useState("")
    const [loading, setLoading] = useState(false)

    const [selectAll, setSelectAll] = useState(false)
    const [selected, setSelected] = useState([])

    async function fetchContacts() {
        try {
            const response = await api.get("/contacts", {
                params: {
                    searchParam,
                    pageNumber,
                },
            })

            setContacts((prevState) => [
                ...prevState,
                ...response.data.contacts?.filter(
                    (item) =>
                        item.channel === "whatsapp" && item.number.length <= 13,
                ),
            ])

            setLoading(false)

            setHasMore(response.data.hasMore)
        } catch (error) {
            setLoading(false)
            toast.error("Erro ao buscar contatos")
        }
    }

    useEffect(() => {
        setLoading(true)
        const delayDebounceFn = setTimeout(() => {
            fetchContacts()
        }, 500)
        return () => clearTimeout(delayDebounceFn)
    }, [searchParam, pageNumber])

    const loadMore = () => {
        setPageNumber((prevState) => prevState + 1)
    }

    const handleScroll = (e) => {
        if (!hasMore || loading) return
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget

        if (scrollHeight - (scrollTop + 100) < clientHeight) {
            loadMore()
        }
    }

    const handleChangeSelectId = (id) => {
        if (selectAll) return

        if (selected.includes(id)) {
            setSelected(selected.filter((item) => item !== id))
        } else {
            const arr = [...selected]
            arr.push(id)
            setSelected(arr)
        }
    }

    const handleClose = () => {
        setSelected([])
        setSelectAll(false)
        onClose()
    }

    return (
        <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Selecionar Contatos</DialogTitle>
            <DialogContent>
                <Paper
                    className={classes.mainPaper}
                    variant="outlined"
                    onScroll={handleScroll}
                >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox" />
                                <TableCell>
                                    {i18n.t("contacts.table.name")}
                                </TableCell>
                                <TableCell align="center">
                                    {i18n.t("contacts.table.whatsapp")}
                                </TableCell>
                                <TableCell align="center">
                                    {i18n.t("contacts.table.email")}
                                </TableCell>
                                <TableCell align="center">
                                    <input
                                        type="checkbox"
                                        id="select-all"
                                        style={{ cursor: "pointer" }}
                                        checked={selectAll}
                                        onChange={() =>
                                            setSelectAll(!selectAll)
                                        }
                                    />
                                    <label
                                        htmlFor="select-all"
                                        style={{ cursor: "pointer" }}
                                    >
                                        Todos
                                    </label>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <>
                                {contacts.map((contact) => (
                                    <TableRow key={contact.id}>
                                        <TableCell style={{ paddingRight: 0 }}>
                                            {
                                                <Avatar
                                                    src={contact.profilePicUrl}
                                                />
                                            }
                                        </TableCell>
                                        <TableCell>{contact.name}</TableCell>
                                        <TableCell align="center">
                                            {contact.number}
                                        </TableCell>
                                        <TableCell align="center">
                                            {contact.email}
                                        </TableCell>
                                        <TableCell align="center">
                                            <input
                                                type="checkbox"
                                                checked={
                                                    selectAll ||
                                                    selected.includes(
                                                        contact.id,
                                                    )
                                                }
                                                onChange={() =>
                                                    handleChangeSelectId(
                                                        contact.id,
                                                    )
                                                }
                                                style={{
                                                    cursor: "pointer",
                                                    padding: 6,
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {loading && (
                                    <TableRowSkeleton avatar columns={3} />
                                )}
                            </>
                        </TableBody>
                    </Table>
                </Paper>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        onImport({ selected, selectAll, type: "contacts" })
                        handleClose()
                    }}
                >
                    Importar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ContactSelectorModal
